import { Component } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-average-daily-ticket-card',
  templateUrl: './average-daily-ticket-card.component.html',
  styleUrls: ['./average-daily-ticket-card.component.scss'],
})
export class AverageDailyTicketCardComponent {
  public isLoaded: boolean = false;
  public averageSales: number = 0;
  public averageSalesPositive: boolean = false;
  public averageSalesPercent: number = 0;

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.getAvailableBalanceAmount();
  }

  getAvailableBalanceAmount() {
    this.isLoaded = true;

    this.dashBoardService
      .getSalesAverage()
      .then((value) => {
        this.averageSales = value.currentValue;
        this.averageSalesPositive = value.percentLastPeriod >= 0 ? true : false;
        this.averageSalesPercent = value.percentLastPeriod;
      })
      .finally(() => {
        this.isLoaded = false;
      });
  }
}
